const BLOB_URL_TTL_MS = 60_000

export const printBlobInNewTab = async (
  blob: Blob,
  openedWindow: Window,
): Promise<void> =>
  new Promise((resolve, reject) => {
    if (openedWindow.closed) {
      reject(
        new Error('Вкладка печати была закрыта до загрузки PDF-документа.'),
      )
      return
    }

    const url = URL.createObjectURL(blob)
    window.setTimeout(() => URL.revokeObjectURL(url), BLOB_URL_TTL_MS)

    const handleLoad = () => {
      try {
        openedWindow.focus()
        openedWindow.print()
        resolve()
      } catch {
        reject(new Error('Не удалось открыть системный диалог печати.'))
      }
    }

    openedWindow.addEventListener('load', handleLoad, { once: true })

    try {
      openedWindow.location.href = url
    } catch {
      openedWindow.removeEventListener('load', handleLoad)
      reject(new Error('Не удалось открыть PDF для печати.'))
    }
  })
